const datetimeStartEnd = (date) => {
  let start = ''
  let end = ''
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  start = year + '-' + month + '-' + day + ' 00:00'
  end = year + '-' + month + '-' + day + ' 23:59'
  return [start, end]
}

const  datetimeStartEndTwo =(dataCur) => {
  let start = ''
  let end = ''
  dataCur = dataCur.getFullYear() + '-' + (dataCur.getMonth() + 1) + '-' + dataCur.getDate() + " 00:00";
  var dataCurPar = Date.parse(new Date(dataCur))/1000;//转换为时间戳
  var curPar =  Date.parse(new Date(dataCur))/1000;//转换为时间戳
  dataCurPar += 86400 * 0;//加7天后的时间戳
  curPar -= 86400 * 1 //减去7天后的时间戳
  var dataC = new Date(parseInt(curPar) * 1000);//转换为时间
  var dataDefPar = new Date(parseInt(dataCurPar) * 1000);//转换为时间
  start = dataC.getFullYear() + '-' + (dataC.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataC.getDate().toString().padStart(2, '0') + ' 00:00');
  end = dataDefPar.getFullYear() + '-' + (dataDefPar.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataDefPar.getDate().toString().padStart(2, '0') + ' 23:59');
  console.log(start, end)
  return [start, end]
}

const datetimeStartEndSevent =(dataCur) => {
  let start = ''
  let end = ''
  dataCur = dataCur.getFullYear() + '-' + (dataCur.getMonth() + 1) + '-' + dataCur.getDate() + " 00:00";
  var dataCurPar = Date.parse(new Date(dataCur))/1000;//转换为时间戳
  var curPar =  Date.parse(new Date(dataCur))/1000;//转换为时间戳
  dataCurPar += 86400 * 7;//加7天后的时间戳
  curPar -= 86400 * 7 //减去7天后的时间戳
  var dataC = new Date(parseInt(curPar) * 1000);//转换为时间
  var dataDefPar = new Date(parseInt(dataCurPar) * 1000);//转换为时间
  start = dataC.getFullYear() + '-' + (dataC.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataC.getDate().toString().padStart(2, '0') + ' 00:00');
  end = dataDefPar.getFullYear() + '-' + (dataDefPar.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataDefPar.getDate().toString().padStart(2, '0') + ' 23:59');
  console.log(start, end)
  return [start, end]
}
const datetimexx = (dataCur, startDay = 0, endDay = 1) => {
    let start = ''
    let end = ''
    dataCur = dataCur.getFullYear() + '-' + (dataCur.getMonth() + 1) + '-' + dataCur.getDate() + " 00:00";
    var dataCurPar = Date.parse(new Date(dataCur)) / 1000; //转换为时间戳
    var curPar = Date.parse(new Date(dataCur)) / 1000; //转换为时间戳
    dataCurPar += 86400 * startDay; //加7天后的时间戳
    curPar -= 86400 * endDay //减去7天后的时间戳
    var dataC = new Date(parseInt(curPar) * 1000); //转换为时间
    var dataDefPar = new Date(parseInt(dataCurPar) * 1000); //转换为时间
    start = dataC.getFullYear() + '-' + (dataC.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataC.getDate().toString().padStart(2, '0') + ' 00:00');
    end = dataDefPar.getFullYear() + '-' + (dataDefPar.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataDefPar.getDate().toString().padStart(2, '0') + ' 23:59');
    console.log(start, end)
    return [start, end]
}
const datetimexxNoMs = (dataCur, startDay = 0, endDay = 1) => {
  let start = ''
  let end = ''
  dataCur = dataCur.getFullYear() + '-' + (dataCur.getMonth() + 1) + '-' + dataCur.getDate() ;
  var dataCurPar = Date.parse(new Date(dataCur)) / 1000; //转换为时间戳
  var curPar = Date.parse(new Date(dataCur)) / 1000; //转换为时间戳
  dataCurPar += 86400 * startDay; //加7天后的时间戳
  curPar -= 86400 * endDay //减去7天后的时间戳
  var dataC = new Date(parseInt(curPar) * 1000); //转换为时间
  var dataDefPar = new Date(parseInt(dataCurPar) * 1000); //转换为时间
  start = dataC.getFullYear() + '-' + (dataC.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataC.getDate().toString().padStart(2, '0') );
  end = dataDefPar.getFullYear() + '-' + (dataDefPar.getMonth() + 1).toString().padStart(2, '0') + '-' + (dataDefPar.getDate().toString().padStart(2, '0') );
  console.log(start, end)
  return [start, end]
}

const getDayFun = (day) => {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  var data = tYear + "-" + tMonth + "-" + tDate;
  return data
}
const doHandleMonth = (month) => {
  var m = month;
  if (month.toString().length == 1) { 
      m = "0" + month;
  }
  return m;
}

const getmonth1st = () => {
  let today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() +1
  return year + '-' + month + '-'+ 1
}
export default {
    datetimeStartEnd,
    datetimeStartEndTwo,
    datetimeStartEndSevent,
    datetimexx,
    datetimexxNoMs,
    getDayFun,
    getmonth1st
}
